module.exports = __webpack_public_path__ + "img/people.be490cad.svg";